import React, { useEffect, useState } from "react";
import { useGetRequest } from "../Utils/hooks/QueryHandler";
import { fetchRecentActivity, formatDate, formatTime } from "../Utils/helpers/commonhelper";
import nodata from "../Utils/assets/img/leads_no_data_found.png"
import { CheckCircle2 } from "lucide-react";
export const ContactActivity = ({ module_id, module_name, headers, extras }) => {
    const [events, setEvents] = useState([])
    useEffect(() => {
        (async () => {
            try {
                const res = await fetchRecentActivity(module_name, module_id, { headers }, extras)
                if (res.status === "fail" || res.success === false) {
                    return
                }

                setEvents(res.data)
            } catch (error) {
                return
            }
        })()
    }, [])

    return (
        <div className="d-flex flex-column justify-content-between align-items-start gap-2 w-100 ">
            {
                module_name !== "lead" && module_name !== "deal" &&
                <>
                    <div style={{ fontSize: "19px", paddingLeft: "16px", paddingTop: '5px', lineHeight: 1.3, fontWeight: 300 }}
                        className="mb-0 ">
                        Activity
                    </div>
                    <hr className="mb-0 w-100 " style={{ marginTop: "8px" }} />
                </>
            }

            <div className="w-100">

                {
                    events ?
                        <div style={{ position: "relative", paddingLeft: "8rem", paddingRight: '2rem', overflowY: 'scroll', scrollBehavior: "smooth", maxHeight: module_name === "lead" || module_name === "deal" ? "32rem" : "40rem" }} className="listStyleForContact">
                            {/* Vertical Timeline Line */}

                            {/* Events Container */}
                            <div className="position-relative">
                                <div style={{ position: "absolute", left: "-2rem", top: 0, bottom: 0, width: "0.125rem", height: 'auto', backgroundColor: "#3b82f6" }} />
                                {events.map((event, index) => (
                                    <div key={index} style={{ position: "relative", marginBottom: "1rem" }}>
                                        <div style={{ position: "absolute", left: "-2rem", top: 0, display: "flex", alignItems: "center", backgroundColor: 'white' }}>
                                            <CheckCircle2 className="w-6 h-6 text-blue-500 " color="#003da0" style={{ marginLeft: '-12px' }} />
                                        </div>

                                        <div style={{ position: "absolute", left: "-8rem", top: 0, textAlign: "right" }}>
                                            <div style={{ fontSize: "0.75rem", fontWeight: 600, color: "#374151" }}>{event?.action === "create" ? formatDate(event?.created_at?.split(" ")[0]) : formatDate(event?.updated_at?.split(" ")[0])}</div>
                                            <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>{event?.action === "create" ? formatTime(event?.created_at?.split(" ")[1]) : formatTime(event?.updated_at?.split(" ")[1])}</div>
                                        </div>

                                        <div style={{ backgroundColor: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "0.5rem", padding: "1rem", boxShadow: "0 1px 2px rgba(0,0,0,0.05)", transition: "box-shadow 0.2s ease-in-out" }}>
                                            <h3 style={{ fontSize: "0.875rem", fontWeight: 600, color: "#111827", marginBottom: "0.5rem", textTransform: "capitalize" }}>
                                                {event?.action === "create" ? `${event?.module_name} created.` : `${event?.module_name} updated.`}
                                            </h3>

                                            <p style={{ fontSize: "0.875rem", color: "#4b5563", marginBottom: "0.5rem" }}>
                                                {event?.action === "create" ? `${event?.module_name} assigned to ${event?.prefix}` : event?.module_name !== "company" ? `${event?.module_name} assigned to ${event?.prefix}` : event?.description}
                                            </p>

                                            <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                                                by <span style={{ fontWeight: 600, color: "#374151", textTransform: "capitalize" }}>{event?.action === "create" ? event?.creator_name : event?.update_name}</span>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div> :
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ position: "absolute", left: `${module_name?.toLowerCase() === "company" ? "19%" : "32%"}` }}
                        >
                            <img
                                src={nodata}
                                alt=""
                                style={{ width: "15rem", marginTop: "0" }}
                            />
                        </div>
                }
            </div>
        </div >
    );
};
